import state from "./moduleTalentPlanPaymentsState.js";
import mutations from "./moduleTalentPlanPaymentsMutations.js";
import actions from "./moduleTalentPlanPaymentsActions.js";
import getters from "./moduleTalentPlanPaymentsGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
